// extracted by mini-css-extract-plugin
var _1 = "Carousel-oA7Nk";
var _2 = "HorizontalSnappedCarousel-TJWWO";
var _3 = "VerticalSnappedCarousel-UuMx4";
export { _1 as "Carousel", _2 as "HorizontalSnappedCarousel", _3 as "VerticalSnappedCarousel" }
